<script>
import resources from './resources'

export default {
  name: 'scheduling-reverser',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row
    .col-xs-12.col-sm-10.col-sm-offset-1
      h4 DESEJA REVERTER A TRANSFERÊNCIA DESTE AGENDAMENTO?
      .row.border-bottom
        .col-xs-12.grey(style='margin-bottom:5px;') Informações do Agendamento Atual
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Dia
          br
          span.blue {{ schedule.date }} ({{ dayOfWeek }})
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Hora
          br
          span.blue {{ schedule.time }}
        .clearfix
        div(style='height:15px;')
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Nome do Profissional
          br
          span.blue {{ schedule.agenda.professional.name }}
          small.grey Especialidade Médica
          br
          span.blue(v-if="schedule.speciality")
            |{{ schedule.speciality.name }}
          span.blue(v-if="!schedule.speciality")
            |Especialidade não informada
          .endereco
            br
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Nome do Paciente
          .blue {{ schedule.patient.name }}
          .detalhes {{ schedule | getValue('patient.degree.name') }}
      .row.border-bottom
        .col-xs-12.dark-grey(style='margin-bottom:15px;') Reverter para a Situação Original do Agendamento:
        .col-xs-12.grey(style='margin-bottom:5px;') Informações do Agendamento Original
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Dia
          br
          span.blue {{ schedule.transfer.date }} ({{ dayOfWeekTransfer }})
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Hora
          br
          span.blue {{ $moment(schedule.transfer.weekday).format('HH:mm') }}
        .clearfix
      .buttons-wrapper
        button.btn.cancel(data-dismiss='modal')
          span.icon 
          |  Não, Voltar
        button.btn.save-filled(@click.prevent="doReverser")
          span.icon 
          |  Sim, Reverter Transferência
</template>



// WEBPACK FOOTER //
// src/app/professional/schedulings/index/components/reverser/reverser.vue